import { render, staticRenderFns } from "./GarankuwaView.vue?vue&type=template&id=53aa9d46&scoped=true&"
import script from "./GarankuwaView.vue?vue&type=script&lang=js&"
export * from "./GarankuwaView.vue?vue&type=script&lang=js&"
import style0 from "./GarankuwaView.vue?vue&type=style&index=0&id=53aa9d46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aa9d46",
  null
  
)

export default component.exports